module.exports = __webpack_public_path__ + "static/media/angle-right.896b558f.svg";